export default __webpack_public_path__ + "static/category-connect-1e5c31d23f104392927128e5577bbb92.svg";